import React from "react";
import {
  Button,
  Checkbox,
  IconButton,
  SearchField,
  SelectField,
  Typography,
} from "@tiny/components";
import Refresh from "@tiny/icons/generated/Refresh";
import TrashFull from "@tiny/icons/generated/TrashFull";
import FindEmailDialog from "../../FindSuppressedEmailDialog";
import { useSuppressionListFilter } from "./SuppressionListFilter.hooks";
import { useStyles } from "./SuppressionListFilter.styles";

function SuppressionListFilter() {
  const classes = useStyles();

  const {
    areAllSelectedOnCurrentPage,
    checkAllDisabled,
    enableBulkDelete,
    enableSelectionActions,
    findEmailDialogOpen,
    hasSelected,
    onChangeSort,
    onCloseFindEmailDialog,
    onDeleteSuppressions,
    openFindEmailDialog,
    reloadSuppressionList,
    searchKeyword,
    selectedText,
    selectionDisabled,
    setSearchKeyword,
    sortOptions,
    sortedBy,
    toggleAllOnCurrentPage,
    unselectAll,
  } = useSuppressionListFilter();

  return (
    <>
      <div className={classes.root}>
        <div className={classes.top}>
          <div className={classes.check}>
            <div>
              <Checkbox
                color="primary"
                checked={areAllSelectedOnCurrentPage}
                onChangeValue={toggleAllOnCurrentPage}
                disabled={checkAllDisabled}
              />
            </div>
          </div>
          {enableSelectionActions && hasSelected ? (
            <div className={classes.selected}>
              {enableBulkDelete && (
                <Button
                  variant="outlined"
                  color="red"
                  endIcon={<TrashFull />}
                  onClick={onDeleteSuppressions}
                  className={classes.deleteButton}
                  disabled={selectionDisabled}
                >
                  Delete
                </Button>
              )}
              <Button
                onClick={unselectAll}
                variant="text"
                noPadding
                disabled={selectionDisabled}
              >
                Deselect all
              </Button>
              <Typography color="grey" tone={600} ml={5} variant="body2">
                {selectedText}
              </Typography>
            </div>
          ) : (
            <div className={classes.search}>
              <SearchField
                value={searchKeyword}
                placeholder="Search"
                onChangeValue={setSearchKeyword}
                className={classes.searchField}
              />
            </div>
          )}
        </div>
        <div className={classes.bottom}>
          <div className={classes.sort}>
            <Button
              variant="outlined"
              color="primary"
              onClick={openFindEmailDialog}
            >
              Find Customer
            </Button>
            <IconButton
              onClick={() => {
                reloadSuppressionList();
              }}
              size="large"
            >
              <Refresh />
            </IconButton>
            <SelectField
              options={sortOptions}
              value={sortedBy}
              onChange={onChangeSort}
              aria-label="Sort"
            />
          </div>
        </div>
      </div>
      <FindEmailDialog
        open={findEmailDialogOpen}
        onClose={onCloseFindEmailDialog}
      />
    </>
  );
}

export default SuppressionListFilter;
